// COMPONENTS
import Dropdown from "./dropdown";

const STRING_COMPARISONS = [
  { value: "is", label: "Is" },
  { value: "includes", label: "Includes" },
  { value: "doesn't include", label: "Doesn't include" },
];

const StringComparisonDropdown = ({ handleChange, value, name }) => {
  return (
    <Dropdown
      handleChange={handleChange}
      value={value}
      name={name}
      options={STRING_COMPARISONS}
    />
  );
};

export default StringComparisonDropdown;
